module.exports = __webpack_public_path__ + "img/login-bg-mobile.057ac880.jpg";